<div class="card flex flex-col sm:flex-row">
  <div class="p-6 md:min-w-[300px]">
    <h2 class="title mt-0 mb-4">Preview</h2>
    <div class="flex flex-col items-center gap-6">
      <button
        (click)="openDialog()"
        color="primary"
        mat-raised-button
        type="button">
        Open Dialog
      </button>
      <p *ngIf="result">You answered with: {{ result }}</p>
    </div>
  </div>

  <div class="border-l flex-1">
    <div class="p-6">
      <h2 class="title mt-0 mb-4">Dialogs</h2>
      <h4 class="body-2 text-secondary m-0">&lt;mat-dialog&gt;</h4>
    </div>

    <mat-tab-group>
      <mat-tab label="DESCRIPTION">
        <p class="p-6">
          Dialogs contain text and UI controls. They retain focus until
          dismissed or a required action has been taken. Use dialogs sparingly
          because they are interruptive.
          <br />
          <br /><span class="semi-bold">Some dialog types include:</span>
          <br /><span class="semi-bold">Alerts</span> are urgent interruptions
          that inform about a situation and require acknowledgement. <br /><span
          class="semi-bold"
        >Simple menus</span
        >
          display options for list items, whereas simple dialogs can provide
          details or actions about a list item. <br /><span class="semi-bold"
        >Confirmation dialogs</span
        >
          require users to explicitly confirm a choice.
        </p>
      </mat-tab>
      <mat-tab label="SOURCE CODE">
        <pre><code [vexHighlight]="dialogHTML"></code></pre>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
